import { Route } from 'react-router-dom';
import { pages } from '../../../utils/common';
import AdministrationView from './administration.view';
import { ProtectedRoute } from '../../../components/rbac/ProtectedRoute';

const useAdministrationRoutes = () => (
  <Route
    path={pages.administration.path}
    element={
      <ProtectedRoute module="administration" checkAnySubmodule>
        <AdministrationView />
      </ProtectedRoute>
    }
  >
    <Route
      index
      element={
        <ProtectedRoute module="administration" checkAnySubmodule>
          <AdministrationView />
        </ProtectedRoute>
      }
    />
    <Route
      path={pages.administration.path + '/:administrationSubRouteId'}
      element={
        <ProtectedRoute module="administration" checkAnySubmodule>
          <AdministrationView />
        </ProtectedRoute>
      }
    />
  </Route>
);

export default useAdministrationRoutes;
